import { useQuery } from "@apollo/client";
import { useState } from "react";
import { GET_QUESTIONS_AS_ADMIN } from "../../lib/apollo/gql/questionGqls";
import { LIMIT } from "../../utilities/constants";

function useQuestionContainer() {
  const [offset, setOffset] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [fetchingMore, setFetchingMore] = useState(false);

  const { data, loading, fetchMore } = useQuery(GET_QUESTIONS_AS_ADMIN, {
    variables: {
      offset: 0,
      limit: LIMIT,
    },
    onCompleted: ({ getQuestionsAsAdmin }) => {
      const { pageInfo } = getQuestionsAsAdmin;

      const { totalPages } = pageInfo;

      setTotalPageCount(totalPages);
      setOffset(pageInfo.offset);
    },
  });

  async function onPageChange({ selected }) {
    const newOffset = selected;
    if (!fetchingMore) {
      setFetchingMore(true);
      await fetchMore({
        variables: {
          offset: newOffset,
          limit: LIMIT,
        },
      });
      setOffset(newOffset);
      setFetchingMore(false);
    }
  }

  return {
    models: {
      loading,
      data: data?.getQuestionsAsAdmin?.edges,
      offset,
      totalPageCount,
    },
    operations: {
      onPageChange,
    },
  };
}

export default useQuestionContainer;
